// This is the app's initial state. Note that reducers each handle a slice of this state.
// Composing all initial state here gives us a clear spot of reference that displays the shape
// of our entire store.
export default {
  customer: {
    id: null,
    photo: '',
    firstName: '',
    middleName: '',
    lastName: '',
    phone: '',
    isCompany: false,
    companyName: '',
    companyType: '',
    address: {
      customerAddressId: null,
      street: '',
      street2: '',
      city: '',
      state: '',
      postal: ''
    }
  },
  ajaxCallsInProgress: 0,
  fuelSavings: {
    newMpg: '',
    tradeMpg: '',
    newPpg: '',
    tradePpg: '',
    milesDriven: '',
    milesDrivenTimeframe: 'week',
    displayResults: false,
    dateModified: null,
    necessaryDataIsProvidedToCalculateSavings: false,
    savings: {
      monthly: '',
      annual: '',
      threeYear: ''
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js